<template>
    <Teleport to="#modal-portal">
        <div
            v-if="isVisible"
            class="safari-z-index fixed inset-0 z-9999 flex items-center justify-center bg-black/65"
        >
            <div class="bg-bg border-stroke-1 mx-4 w-full max-w-md border shadow-xl">
                <div class="p-4">
                    <div class="text-center text-sm">
                        <slot></slot>
                    </div>
                </div>

                <div
                    class="border-stroke-1 mt-2 grid gap-4 border-t p-4"
                    :class="gridColsClass"
                >
                    <DiagonalCutButton
                        v-if="!hideCancel"
                        @click="onDecline"
                        variant="secondary"
                        cut-position="right-top"
                        :disabled="isLoading"
                        data-testid="modal-decline"
                    >
                        {{ cancelText || $t('general.cancel') }}
                    </DiagonalCutButton>
                    <DiagonalCutButton
                        v-if="onExtra"
                        @click="onExtra"
                        variant="secondary-white"
                        cut-position="both-top"
                        :disabled="isLoading"
                        data-testid="modal-extra"
                    >
                        {{ extraText }}
                    </DiagonalCutButton>
                    <DiagonalCutButton
                        @click="onConfirm"
                        variant="primary"
                        cut-position="left-top"
                        :disabled="isLoading"
                        :is-loading="isLoading"
                        data-testid="modal-confirm"
                    >
                        {{ confirmText || $t('general.confirm') }}
                    </DiagonalCutButton>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script>
import DiagonalCutButton from '@/components/ui/DiagonalCutButton.vue'

export default {
    name: 'Modal',
    components: { DiagonalCutButton },
    props: {
        isVisible: {
            type: Boolean,
            default: false,
        },

        onConfirm: {
            type: Function,
            default: () => {
                console.log('Pressed confirm')
            },
        },

        onDecline: {
            type: Function,
            default: () => {
                console.log('Pressed decline')
            },
        },
        /** Optional third action rendered between decline and confirm. Omit to keep the default two-button layout. */
        onExtra: {
            type: Function,
            default: null,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        confirmText: {
            type: String,
            default: null,
        },
        cancelText: {
            type: String,
            default: null,
        },
        extraText: {
            type: String,
            default: null,
        },
        hideCancel: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        gridColsClass() {
            const buttonCount = (this.hideCancel ? 0 : 1) + (this.onExtra ? 1 : 0) + 1
            return { 1: 'grid-cols-1', 2: 'grid-cols-2', 3: 'grid-cols-3' }[buttonCount]
        },
    },
    methods: {},
}
</script>

<style>
.safari-z-index {
    z-index: 9999;
    -webkit-transform: translate3d(0, 0, 0);
}
</style>
